import { useSuspenseQuery } from "@apollo/client";
import { createFileRoute } from "@tanstack/react-router";
import { zodValidator } from "@tanstack/zod-adapter";
import { z } from "zod";

import { CreateNonResponse } from "@/features/FillOutWizard/CreateNonResponse";
import { NonResponseFormQuery } from "@/features/FillOutWizard/CreateNonResponse/graphql";
import { zodRespondentTypeEnum } from "@/models/respondent";

export const Route = createFileRoute(
  "/$organizationKey/$dossierId/fill_out_wizard/$measurementId/create_non_response",
)({
  validateSearch: zodValidator(
    z.object({
      respondentType: zodRespondentTypeEnum,
      measuredQuestionnaireIds: z.array(z.string()),
    }),
  ),
  component: RouteComponent,
});

function RouteComponent() {
  const { organizationKey, measurementId } = Route.useParams();
  const { respondentType, measuredQuestionnaireIds } = Route.useSearch();
  const { data } = useSuspenseQuery(NonResponseFormQuery, {
    variables: { organizationKey, measurementId, measuredQuestionnaireIds },
  });

  return (
    <CreateNonResponse
      measurement={data.organization.measurement}
      respondentType={respondentType}
      measuredQuestionnaireIds={measuredQuestionnaireIds}
    />
  );
}
